"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMinterAddress = exports.findMintWrapperAddress = void 0;
const tslib_1 = require("tslib");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
const findMintWrapperAddress = (base, programID = constants_1.SUNNY_ADDRESSES.MintWrapper) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([Buffer.from(anchor_1.utils.bytes.utf8.encode("MintWrapper")), base.toBytes()], programID);
});
exports.findMintWrapperAddress = findMintWrapperAddress;
const findMinterAddress = (wrapper, authority, programID = constants_1.SUNNY_ADDRESSES.MintWrapper) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        Buffer.from(anchor_1.utils.bytes.utf8.encode("MintWrapperMinter")),
        wrapper.toBytes(),
        authority.toBytes(),
    ], programID);
});
exports.findMinterAddress = findMinterAddress;
//# sourceMappingURL=pda.js.map